import graphQl from '../../../services/graphQl';
import { Commit, ActionTree, Dispatch } from 'vuex';
// import { State } from './home.store';
import * as types from '../apm/mutation-types';
import axios, { AxiosPromise, AxiosResponse } from 'axios';
// import { State } from './dashboard-data';
import fragmentAll from '../apm/dashboard/dashboard.metrcis.types';
import axiosInstance from '@/services/api/http.service';
import getEnv from '@/utils/env';
import graphHelpers from '@/utils/graphHelper';
import { MetricName, OSType, Scope } from '@/components/Mobile/constants';
import allfragments from '@/services/graphQl/fragments/graph';
import rootStateStore, {
  State
} from '../apm/apmCommonState/apmCommonState.store';
import {
  CAPABILITY_APM,
  CAPABILITY_BROWSER,
  CAPABILITY_LOG,
  CAPABILITY_MOBILE,
  CAPABILITY_ANALYTICS,
  CAPABILITY_DBM,
  CAPABILITY_DATABASE
} from '@/utils/constants';
import { CAPABILITY_CLOUD } from '@/components/Cloud/services/aws/aws.services.types';
import {
  NAVTABS,
  BROWSER_ENTIY
} from '@/utils/templates/Browser/browser.constants';

const OAP_HOST = getEnv('VUE_APP_OAP_HOST') || 'http://localhost:12800';

export enum TopologyType {
  TOPOLOGY_ENDPOINT = 'TOPOLOGY_ENDPOINT',
  TOPOLOGY_INSTANCE = 'TOPOLOGY_INSTANCE'
}

// actions
const actions: ActionTree<State, any> = {
  SET_APP_SPAN_VIEW(context, payload) {
    context.commit(types.SET_APP_SPAN_VIEW, payload);
  },
  GET_APPLICATION_META(
    context: { commit: Commit },
    params: {
      agentId: string;
    }
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl
          .query('queryGetTeamApplication')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (!res.data.data) {
              console.error(res.data);
              throw Error(res.data);
            } else {
              context.commit(
                types.SET_APPLICATION_META,
                res.data.data.getTeamApplicationOverview
              );
              resolve();
            }
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      }
    });
  },

  GET_BROWSER_META(
    context: { commit: Commit },
    params: {
      agentId: string;
    }
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl
          .query('queryGetTeamApplication')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (!res.data.data) {
              console.error(res.data);
              throw Error(res.data);
            } else {
              context.commit(
                types.SET_BROWSER_META,
                res.data.data.getTeamApplicationOverview
              );
              resolve();
            }
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      }
    });
  },

  GET_MOBILE_META(
    context: { commit: Commit },
    params: {
      agentId: string;
    }
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl
          .query('queryGetTeamApplication')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (!res.data.data) {
              console.error(res.data);
              throw Error(res.data);
            } else {
              context.commit(
                types.SET_MOBILE_META,
                res.data.data.getTeamApplicationOverview
              );
              resolve();
            }
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      }
    });
  },

  GET_ENDPOINT_META(
    context: { commit: Commit },
    params: {
      agentId: string;
    }
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl
          .query('queryGetTeamEndpoint')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (!res.data.data) {
              console.error(res.data);
              throw Error(res.data);
            } else {
              context.commit(
                types.SET_ENDPOINT_META,
                res.data.data.getTeamEndpointOverview
              );
              resolve();
            }
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      }
    });
  },

  GET_RECENT_ALERTS(
    context: { commit: Commit },
    params: {
      agentId: string;
    }
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl
          .query('queryGetTeamAlarm')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (!res.data.data) {
              console.error(res.data);
              throw Error(res.data);
            } else {
              context.commit(
                types.SET_RECENT_ALERTS,
                res.data.data.getAlarmForTeam.msgs
              );
              resolve();
            }
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
  async getGraphData(
    context: {
      commit: Commit;
      dispatch: Dispatch;
      getters: any;
      rootState: any;
      state: any;
    },
    params: {
      index: number;
      duration: any;
      type: string;
      dashboardType: { type: string; isDatabase: boolean };
      isSlow: { type: boolean };
      layoutIndex: number;
      children: { present: boolean; childIndex: number };
      chartConfig: any;
    }
  ) {
    switch (params.chartConfig.capability) {
      case CAPABILITY_APM:
        return await context.dispatch('homeState/getQuery', params, {
          root: true
        });
      case CAPABILITY_BROWSER:
        return await context.dispatch('homeState/getBrowserGraphData', params, {
          root: true
        });
      case CAPABILITY_MOBILE:
        return await context.dispatch('homeState/getMobileGraphData', params, {
          root: true
        });
      case CAPABILITY_LOG:
        return await context.dispatch(
          'logState/logCommonState/getLogDashboardWidgetData',
          params,
          { root: true }
        );
     case CAPABILITY_DBM:
        return await context.dispatch(
          'globalState/settings/getCustomDBDashboardWidgetData',
          params,
          { root: true }
        );
      case CAPABILITY_DATABASE:
        return await context.dispatch(
          'globalState/settings/getCustomDBDashboardWidgetData',
          params,
          { root: true }
        );
        case CAPABILITY_CLOUD:
          return await context.dispatch(
            'cloudState/detail/getGraphDataForCustomDashboard',
            params,
            { root: true }
          );
      default:
        return await context.dispatch('homeState/getBrowserGraphData', params, {
          root: true
        });
    }
  },

  async getLabelData(
    context: {
      commit: Commit;
      dispatch: Dispatch;
      getters: any;
      rootState: any;
      state: any;
    },
    params: {
      duration: any;
      config: any;
    }
  ) {
    switch (params.config.capability) {
      case CAPABILITY_LOG:
      case CAPABILITY_ANALYTICS:
        return await context.dispatch(
          'logState/logCommonState/getLogDashboardWidgetData',
          params,
          { root: true }
        );
      case CAPABILITY_DBM:
        return await context.dispatch(
         'globalState/settings/getCustomDBDashboardWidgetData',
         params,
          { root: true }
          );
    }
  },

  getQuery(
    context: {
      commit: Commit;
      dispatch: Dispatch;
      getters: any;
      rootState: any;
    },
    params: {
      index: number;
      duration: any;
      type: string;
      dashboardType: { type: string; isDatabase: boolean };
      isSlow: { type: boolean };
      layoutIndex: number;
      children: { present: boolean; childIndex: number };
      chartConfig: any;
    }
  ) {
    const {
      currentDatabaseService,
      currentEndpoint,
      currentInstance,
      currentService
    } = context.rootState.apmState.apmCommonState;
    //noraml is true for apm service,endpoint and instance
    // normal will be false for database
    // TODO
    // Changing the var from normal to something meaningful requires backend changes so it will TODO
    const normal = params.dashboardType.isDatabase ? false : true;

    let config = {} as any;
    const names = ['readSampledRecords', 'sortMetrics'];

    // Check the entity type and set the configs accordingly
    config = params.chartConfig;
    // if (!normal) {

    //   if (params.children.present) {
    //     config =
    //       context.rootState.globalState.app.chartsTemplate.appdb[
    //         params.layoutIndex
    //       ][params.index].childQueries[params.children.childIndex];
    //   } else {
    //     config =
    //       context.rootState.globalState.app.chartsTemplate.appdb[
    //         params.layoutIndex
    //       ][params.index];
    //   }
    // }
    if (!config) {
      return;
    }
    if (!config.metricName) {
      return;
    }
    // remove the space at the beginning and end of the string
    const metricNames = config.metricName
      .split(',')
      .map((item: string) => item.replace(/^\s*|\s*$/g, ''));
    const labelsIndex = (config.labelsIndex || '')
      .split(',')
      .map((item: string) => item.replace(/^\s*|\s*$/g, ''));
    const currentServiceId = config.serviceKey;
    const currentInstanceId = config.instanceName;
    const currentEndpointId = config.endpointName;
    const currentDatabaseId = config.independentSelector
      ? config.currentDatabase
      : currentDatabaseService.key;
    const labels =
      config.metricType === 'LABELED_VALUE' ? labelsIndex : undefined;
    const variablesList = metricNames.map((name: string) => {
      let variables = {} as any;
      // This is for globhal dashboard
      if (config.entityType === 'All') {
        variables = names.includes(config.queryMetricType)
          ? {
            duration: params.duration,
            condition: {
              name,
              parentService: null,
              normal: true,
              scope: config.entityType,
              topN: 10,
              order: config.sortOrder || 'DES'
            }
          }
          : {
            duration: params.duration,
            condition: {
              name,
              entity: {
                scope: config.entityType,
                normal: true
              }
            },
            labels
          };
      } else {
        if (names.includes(config.queryMetricType)) {
          // this is probably for slow traces
          const parentService = normal ? currentServiceId : currentDatabaseId;
          if (config.parentService && !parentService) {
            return;
          }
          variables = {
            duration: params.duration,
            condition: {
              name,
              parentService: config.parentService ? currentService.key : null,
              normal,
              scope: normal
                ? config.entityType
                : config.parentService
                  ? 'Service'
                  : config.entityType,
              topN: 10,
              order: config.sortOrder || 'DES'
            }
          };
        } else {
          const serviceName = normal ? currentServiceId : currentDatabaseId;
          if (!serviceName) {
            return null;
          }
          if (config.entityType === 'ServiceInstance' && !currentInstanceId) {
            return null;
          }
          if (config.entityType === 'Endpoint' && !currentEndpointId) {
            return null;
          }
          variables = {
            duration: params.duration,
            condition: {
              name,
              entity: {
                scope: normal ? config.entityType : 'Service',
                serviceName,
                serviceInstanceName:
                  config.entityType === 'ServiceInstance'
                    ? currentInstanceId
                    : undefined,
                endpointName:
                  config.entityType === 'Endpoint'
                    ? currentEndpointId
                    : undefined,
                normal
                // destNormal: normal,
                // destServiceName: '',
                // destServiceInstanceName: '',
                // destEndpointName: '',
              }
            },
            labels
          };
        }
      }

      return variables;
    });

    const globalArr: any = fragmentAll;
    if (!config.queryMetricType || !variablesList.length) {
      return;
    }
    const fragments = globalArr[config.queryMetricType].fragment;
    const queryVariables = globalArr[config.queryMetricType].variable;
    const query = `query queryData(${queryVariables}) {${fragments}}`;
    return Promise.all(
      variablesList.map((variable: any) => {
        if (variable) {
          return new axiosInstance({ auth: true })
            .post(
              OAP_HOST + '/graphql',
              { query, variables: variable },
              {
                // cancelToken: cancelToken()
              }
            )
            .then((res: AxiosResponse<any>) => {
              const resData = res.data.data;
              return {
                ...resData,
                config,
                metricName: variable.condition.name
              };
            }).catch(err=>err);
        } else {
          return { config };
        }
      })
    ).then((data: any) => {
      return data;
    }).catch(err=>err);
  },

  getBrowserGraphData(
    context: {
      commit: Commit;
      dispatch: Dispatch;
      getters: any;
      rootState: any;
    },
    params: {
      index: number;
      duration: any;
      type: string;
      dashboardType: { type: string; isDatabase: boolean };
      layoutIndex: number;
      children: { present: boolean; childIndex: number };
      chartConfig: any;
    }
  ) {
    const {
      currentBrowserPage,
      currentBrowserVersion,
      currentBrowserService
    } = context.rootState.browserState.browserCommonState;
    /**
     *
     * variable  for determining the service type .
     * @description this is database query , if normal is true then the entity is database else it is for application
     * @param {boolean}
     */
    const normal = params.dashboardType.isDatabase ? false : true;

    let config = {} as any;
    const names = ['readSampledRecords', 'sortMetrics'];
    config = params.chartConfig;
    if (!config) {
      return;
    }
    if (!config.metricName) {
      return;
    }
    /**
     * @description remove the space at the beginning and end of the string.
     */
    const metricNames = config.metricName
      .split(',')
      .map((item: string) => item.replace(/^\s*|\s*$/g, ''));
    const labelsIndex = (config.labelsIndex || '')
      .split(',')
      .map((item: string) => item.replace(/^\s*|\s*$/g, ''));
    /**
     * @description add the current browser service to the ID
     * @param {string}
     */
    const currentBrowserServiceId = config.serviceKey;
    /**
     * @description add the current version tag  to the ID.
     * @param {string}
     */
    const currentBrowserVersionId = config.independentSelector
      ? config.currentBrowserVersion
      : currentBrowserVersion.key;
    /**
     * @description add the current browser page to the ID.
     * @param {string}
     */
    const currentBrowserPageId = config.independentSelector
      ? config.currentBrowserPage
      : currentBrowserPage.key;
    const labels =
      config.metricType === 'LABELED_VALUE' ? labelsIndex : undefined;
    /**
     * @constant
     * @example
     *  * # Contents of `variablesList`
     * ```Array
     * [
     *   {
     *  "duration": {
     *    "start": "2021-06-09",
     *     "end": "2021-07-09",
     *      "step": "DAY"
     *  },
     *   "condition": {
     *    "name": "service_apdex",
     *     "entity": {
     *          "scope": "Service",
     *        "serviceName": "eyduYW1lJzonZ28tYXBpLXVzZXInLCd0ZWFtSUQnOidiNzA2ODFhOC00ZWI3LTQ2OGYtOGJlNi04NWRlZDQ1NzEyM2EnLCd0eXBlJzonQSd9.1",
     *       "normal": true
     *     }
     *  }
     * }
     * ]
     * ```
     * @description creates the variable for grqphQL API
     *
     */
    const variablesList: Array<any> = metricNames.map((name: string) => {
      let variables = {} as any;
      /**
       * @description This is for getting global data
       */
      if (config.entityType === 'All') {
        variables = names.includes(config.queryMetricType)
          ? {
            duration: params.duration,
            condition: {
              name,
              parentService: null,
              normal: true,
              scope: config.entityType,
              topN: 10,
              order: config.sortOrder || 'DES'
            }
          }
          : {
            duration: params.duration,
            condition: {
              name,
              entity: {
                scope: config.entityType,
                normal: true
              }
            },
            labels
          };
      } else {
        /**
         * @description This macthes the query types and constructs the graphQL API
         * @example
         *  * # Contents of `variablesList`
         * ```
         *  "name": "service_apdex",
         *  * ```
         */
        if (names.includes(config.queryMetricType)) {
          const parentService = normal ? currentBrowserServiceId : '';
          if (config.parentService && !parentService) {
            return;
          }
          variables = {
            duration: params.duration,
            condition: {
              name,
              parentService: config.parentService
                ? currentBrowserService.key
                : null,
              normal,
              scope: normal
                ? config.entityType
                : config.parentService
                  ? 'Service'
                  : config.entityType,
              topN: 10,
              order: config.sortOrder || 'DES'
            }
          };
        } else {
          const serviceName = normal ? currentBrowserServiceId : null;
          if (!serviceName) {
            return null;
          }
          if (
            config.entityType === BROWSER_ENTIY.BROWSER_VERSION_ENTITY &&
            !currentBrowserVersionId
          ) {
            return null;
          }
          if (
            config.entityType === BROWSER_ENTIY.BROWSER_PAGE_ENTITY &&
            !currentBrowserPageId
          ) {
            return null;
          }
          /**
           * @description variable constructor
           */
          variables = {
            duration: params.duration,
            condition: {
              name,
              entity: {
                scope: normal
                  ? config.entityType
                  : BROWSER_ENTIY.BROWSER_APPLICATION_ENTITY,
                serviceName,
                serviceInstanceName:
                  config.entityType === BROWSER_ENTIY.BROWSER_VERSION_ENTITY
                    ? currentBrowserVersionId
                    : undefined,
                endpointName:
                  config.entityType === BROWSER_ENTIY.BROWSER_PAGE_ENTITY
                    ? currentBrowserPageId
                    : undefined,
                normal
              }
            },
            labels
          };
        }
      }

      return variables;
    });

    const globalArr: any = fragmentAll;
    if (!config.queryMetricType || !variablesList.length) {
      return;
    }
    const fragments = globalArr[config.queryMetricType].fragment;
    const queryVariables = globalArr[config.queryMetricType].variable;
    const query = `query queryData(${queryVariables}) {${fragments}}`;
    return Promise.all(
      variablesList.map((variable: any) => {
        if (variable) {
          return new axiosInstance({ auth: true })
            .post(
              OAP_HOST + '/graphql',
              { query, variables: variable },
              {
                // cancelToken: cancelToken()
              }
            )
            .then((res: AxiosResponse<any>) => {
              const resData = res.data.data;
              return {
                ...resData,
                config,
                metricName: variable.condition.name
              };
            }).catch(err=>err);
        } else {
          return { config };
        }
      })
    ).then((data: any) => {
      return data;
    }).catch(err=>err);
  },
  getMobileGraphData(
    context: {
      commit: Commit;
      dispatch: Dispatch;
      getters: any;
      rootState: any;
    },
    params: {
      index: number;
      duration: any;
      type: string;
      dashboardType: { type: string; isDatabase: boolean };
      layoutIndex: number;
      children: { present: boolean; childIndex: number };
      chartConfig: any;
      dependency: string;
      metricName: string;
      compareDuration: any;
    }
  ) {
    const {
      currentMobileAppVersion,
      currentMobileOS,
      currentMobileService
    } = context.rootState.mobileState.mobileCommonState;
    const normal = params.dashboardType.isDatabase ? false : true;

    let config = {} as any;
    const names = ['readSampledRecords', 'sortMetrics'];
    config = params.chartConfig;
    if (!config) {
      return;
    }
    if (!config.metricName) {
      return;
    }
    const metricNames = config.metricName
      .split(',')
      .map((item: string) => item.replace(/^\s*|\s*$/g, ''));
    const labelsIndex = (config.labelsIndex || '')
      .split(',')
      .map((item: string) => item.replace(/^\s*|\s*$/g, ''));
    const currentMobileId = config.serviceKey;
    const currentMobileAppVersionId = config.independentSelector
      ? config.currentMobileAppVersion
      : currentMobileAppVersion.key;
    const currentMobileOSId = config.independentSelector
      ? config.currentMobileOS
      : currentMobileOS.key;
    const labels =
      config.metricType === 'LABELED_VALUE' ? labelsIndex : undefined;

    let variablesList: any;
    if (config.customMetricName === 'crashByFilter' || config.customMetricName === 'usage') {
      variablesList = [
        {
          request: {
            duration: params.duration,
            filterType: config.filterType,
            serviceId: currentMobileId,
            os: ["IOS", "ANDROID"],
            versionId: []
          }
          // labels: ""
        }
      ];
    }
    else if (config.customMetricName === 'activeUsersByOs' || config.customMetricName === 'appEventsByOs' || config.customMetricName === 'newRegisteredUsers') {
      variablesList = [{
        condition: {
          duration: params.duration,
          serviceId: currentMobileId,
          os: ["IOS", "ANDROID"],
          versionId: []
        }
      }];
    }
    else if (config.queryMetricType === "readCustomMetricsValues" && config.entityType === "Mobile") {
      let entiry_temp: any;
      if (config.metricName === 'mobile_app_perf_user_impacted') {
        entiry_temp = {
          entity: {
            scope: config.entityType,
            serviceName: currentMobileId,
            normal: true,
            os: ["IOS", "ANDROID"],
            versionIds: []
          }
        };
      } else {
        entiry_temp = {
          entity: {
            scope: config.entityType,
            serviceName: currentMobileId,
            normal: true,
            os: ["IOS", "ANDROID"],
            versionId: []
          }
        };
      }
      variablesList = [
        {
          duration: params.duration,
          condition: {
            name: config.metricName,
            entity: entiry_temp.entity
          }
        }
      ];
    }

    else {
      variablesList = graphHelpers.createVariableList(
        metricNames,
        params,
        config,
        names,
        labels,
        normal,
        currentMobileId
      );
    }
    if (!variablesList || !variablesList.length) {
      return;
    }
    return Promise.all(
      variablesList.map((variable: any) => {
        if (variable) {
          if (variable.request || config.isUsages) {
            const fragments = allfragments[config.customMetricName].query;
            const queryVariables =
              allfragments[config.customMetricName].variable;
            const query = `query ${config.customMetricName}(${queryVariables}) {${fragments}}`;
            axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
            return new axiosInstance({ auth: true })
              .post(
                OAP_HOST + '/graphql',
                { query, variables: variable },
                {
                  // cancelToken: cancelToken()
                }
              )
              .then((res: AxiosResponse<any>) => {
                let resData = res.data.data.response.values;
                if (!resData.length) {
                  let newDataPoints: Array<object> = [];
                  resData.values.forEach(function (arrayItem: any) {
                    newDataPoints.push(arrayItem.value)
                  });
                  resData = [];
                  resData[0] = {
                    key: config.customMetricName,
                    values: newDataPoints
                  };
                }
                let _tempArray: Object[] = [];
                _tempArray[config.queryMetricType] = [];
                if (!(resData instanceof Array)) {
                  let _tempObj = {
                    label: config.customMetricName,
                    values: {
                      values: resData.values.map((i: any) => i.value)
                    }
                  };
                  _tempArray[config.queryMetricType] = _tempObj;
                  return {
                    ..._tempArray,
                    config,
                    metricName: config.customMetricName
                  }
                }
                resData.forEach((element, index) => {
                  let _tempObj = {
                    label: element.key,
                    values: {
                      values: element.values
                    }
                  };
                  if (config.chartType === 'ApexChartLine') {
                    _tempArray[config.queryMetricType] = _tempObj;
                  } else _tempArray[config.queryMetricType][index] = _tempObj;
                });
                return {
                  ..._tempArray,
                  config,
                  metricName: variable.request ? variable.request.filterType : config.customMetricName
                };
              }).catch(err=>err);
          } else {
            const currentSetMobileOS =
              context.rootState.mobileState.mobileCommonState.currentMobileOS;
            const currentVersion =
              context.rootState.mobileState.mobileCommonState
                .currentMobileAppVersion;
            const selectedMobileOSs = currentSetMobileOS
              ? currentSetMobileOS
              : { key: OSType.OS_ALL, label: 'All' };
            if (config.isCrashes) {
              if (currentVersion.key && currentVersion.key != 'all') {
                variable.condition.entity['scope'] = Scope.SERVICEINSTANCE

                variable.condition.entity['serviceInstanceName'] = currentVersion.key
                variable.condition.name = MetricName.MOBILE_APP_VERSION_CRASH_COUNT;
              } else {
                if (selectedMobileOSs.key === OSType.OS_ALL) {
                  variable.condition.name = MetricName.MOBILE_APP_CRASH_COUNT;
                  config.metricName = MetricName.MOBILE_APP_CRASH_COUNT;
                }
              }
            }
            if (config.isPerformance) {
              if (currentVersion.key && currentVersion.key != 'all') {
                variable.condition.entity['scope'] = Scope.SERVICEINSTANCE
                variable.condition.entity['serviceInstanceName'] = currentVersion.key
                variable.condition.name = MetricName.MOBILE_APP_VERSION_COUNT
              } else {
                if (selectedMobileOSs.key === OSType.OS_ALL) {
                  variable.condition.name = MetricName.MOBILE_APP_NORMAL_COUNT;
                  config.metricName = MetricName.MOBILE_APP_NORMAL_COUNT;
                }
              }
            }
            if (config.isPerformanceResponseTime) {
              if (currentVersion.key && currentVersion.key != 'all') {
                variable.condition.entity['scope'] = Scope.SERVICEINSTANCE
                variable.condition.entity['serviceInstanceName'] = currentVersion.key
                variable.condition.name = MetricName.MOBILE_APP_PERF_VERSION_RESPONSE_TIME
              } else {
                if (selectedMobileOSs.key === OSType.OS_ALL) {
                  variable.condition.name =
                    MetricName.MOBILE_APP_PERF_RESPONSE_TIME;
                  config.metricName = MetricName.MOBILE_APP_PERF_RESPONSE_TIME;
                }
              }
            }
            return graphQl
              .graphQuery(variable, config.queryMetricType)
              .then((res: AxiosResponse<any>) => {
                let resData = res.data.data;
                return {
                  ...resData,
                  config,
                  metricName: variable.condition.name
                };
              }).catch(err=>err);
          }
        } else {
          return { config };
        }
      })
    ).then((data: any) => {
      return data;
    }).catch(err=>err);
  },
  getSummaryMetricData(context, params) {
    return graphQl
      .query('queryDashboardSummary')
      .params(params)
      .then((res: AxiosResponse<any>) => {
        return res.data;
      });
  },
  GET_METRIC_RATE(
    context: { commit: Commit },
    params: any
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl
          .query('queryMetricRate')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (!res.data) {
              throw Error(res.data);
            } else {
              resolve(res.data.data.readMetricsPercentage.value);
            }
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      }
    });
  },
  getApdexAppList(context, params) {
    return graphQl
      .query('queryApdexAppList')
      .params(params)
      .then((res: AxiosResponse<any>) => {
        return res.data.data.getTeamApplicationOverview;
      });
  },
};

export default actions;
